export const exampleGroups = [
  {
    id: "workouts",
    title: "Workouts",
    description:
      "Training direkt an der Anlage. So wird aus einem Scan eine neue Übung.",
    videos: [
      {
        url: "https://player.vimeo.com/progressive_redirect/playback/753955542/rendition/540p/file.mp4?loc=external&signature=40aa592ea17caf03bf4a22aa98eba6a0ea39d4b3bc949f06edec5986e60fd91f",
        title: "TCB Workout Challenge #1",
        preview: "/videos/showcase/workout-tcb.mp4",
        poster: "/videos/showcase/workout-tcb.jpg",
      },
      {
        url: "https://player.vimeo.com/progressive_redirect/playback/749163521/rendition/540p/file.mp4?loc=external&signature=78bf78f1a50043f0a5e7730f40be58443ce0e901f4b00c444b46b418746e3a17",
        title: "Flexdex Workout Challenge",
        preview: "/videos/showcase/workout-flexdex.mp4",
        poster: "/videos/showcase/workout-flexdex.jpg",
      },
    ],
  },
  {
    id: "parkour",
    title: "Parkour",
    description:
      "Techniken kennenlernen und Bewegungen Schritt für Schritt ausprobieren.",
    videos: [
      {
        url: "https://player.vimeo.com/progressive_redirect/playback/753954734/rendition/540p/file.mp4?loc=external&signature=37e91e14182a7639d0591862c09f2c3da352402ac0d78746a6c913c5f0692675",
        title: "TCB Parkour Challenge #1",
        preview: "/videos/showcase/parkour-tcb.mp4",
        poster: "/videos/showcase/parkour-tcb.jpg",
      },
      {
        url: "https://player.vimeo.com/progressive_redirect/playback/749163359/rendition/540p/file.mp4?loc=external&signature=671a18fecc006163817258d5e79961696b6685650f3faa4d51bf23ab47e349e2",
        title: "Flexdex Parkour Challenge",
        preview: "/videos/showcase/parkour-flexdex.mp4",
        poster: "/videos/showcase/parkour-flexdex.jpg",
      },
    ],
  },
  {
    id: "games",
    title: "Spiele",
    description: "Spielerische Challenges, die zum Mitmachen einladen.",
    videos: [
      {
        url: "https://player.vimeo.com/progressive_redirect/playback/753953839/rendition/540p/file.mp4?loc=external&signature=013c46bb4459a88a93278156a7d18aa7b49a9abf04a1edbc9b5581f4239c758a",
        title: "TCB Game Challenge #1",
        preview: "/videos/showcase/game-tcb-1.mp4",
        poster: "/videos/showcase/game-tcb-1.jpg",
      },
      {
        url: "https://player.vimeo.com/progressive_redirect/playback/753954305/rendition/540p/file.mp4?loc=external&signature=f8b1399e89bf438d55362583b8292e47b949a639ac453cbea69da24e763503c6",
        title: "TCB Game Challenge #2",
        preview: "/videos/showcase/game-tcb-2.mp4",
        poster: "/videos/showcase/game-tcb-2.jpg",
      },
    ],
  },
];
